<template>
  <div>
    <label class="criteria-label d-block">
      Describa los criterios y procedimientos que se utilizarán para evaluar el progreso del estudiante:
    </label>
    <span>{{ value }}</span>
  </div>
</template>

<script>

export default {
  name: 'PlanCriterias',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';

.criteria-label {
  font-size: 0.875rem;
  color: map-get($colors, 'gray-6');
  font-weight: bold;
}
</style>
